import ChoiceListSection from './ChoiceListSection.jsx';

const ToggleListSection = ({ section }) => (
  <ChoiceListSection section={section} control="switch" multiple maxVisible={4} />
);

export default ToggleListSection;
